<template>
<div>
        <div id="members">
                <div class="content-bottom">
                        <div>
                                <h1 class="text-center" style="border-bottom: 1px solid #a3a4a5;">Contacts</h1>
                        </div>
                        <div class="list-group">
                                <ul class="nav nav-tabs flex flex-row justify-content-center" style="border-bottom:none;">
                                        
                                        <div class="w-100">
                        <input type="text" v-model="searchTerm" class="w-100 p-3 form-control mb-3" placeholder="Search...">

                                                <button class="btn-primary w-100" @click="toggle" style="padding:5px;border-radius:20px;">Show {{onlyOnline?'All':'Online'}}</button>
                                        </div>

                                        <li v-for="user in filteredList" :key="user.id" style="width:100%">
                                                <a :href="'#' + user.id" class="data-items" @click.prevent="$emit('currentuser', user)">
                                                        <img class="avatar-md" :src="user.imageUrl" alt="" />
                                                        <div class="status" :class="[ user.isOnline ? 'isOnline' : 'isOffline' ]">
                                                                <i class="material-icons " style="font-size:20px;">fiber_manual_record</i>
                                                        </div>
                                                        <div class="data">
                                                                <h5>{{user.name}}</h5>
                                                                <p style="color:black;">{{user.isTutor?'Tutor':''}}</p>

                                                        </div>
                                                </a>
                                        </li>
                                </ul>
                        </div>
                </div>
        </div>
</div>
</template>

<script>
export default {
        props: ['users'],
        data: function () {
                return {
                        onlyOnline: false,
                        searchTerm: '',
                }
        },
        computed: {
                filteredList() {
                        if (this.onlyOnline) {
                                return this.users.filter(user => user != undefined && user.name!=undefined && user.isOnline && (user.name.toLowerCase().includes(this.searchTerm.toLowerCase())));
                        } else {
                                return this.users.filter(user => user != undefined && user.name!=undefined && (user.name.toLowerCase().includes(this.searchTerm.toLowerCase())));
                        }
                }
        },
        methods: {
                toggle() {
                        this.onlyOnline = !this.onlyOnline
                },

        }

}
</script>

<style scoped>
.isOnline {
        color: green !important;
}

.isOffline {
        color: red !important;
}
</style>
